import Button from "../Button/Button";
import CoinsIcon from "../../../assets/img/icons/coins.svg";

const ProspectusErrorScreen = ({ closeModal }) => {
  return (
    <div className="success-screen success-screen_inner-padding">
      <div className="success-screen__content">
        <div>
          <img src={CoinsIcon} alt="" />
        </div>

        <span className="h7 text-blue">
          Истек срок подписания заявки, создайте новую
        </span>
        <p className="text-gray" style={{ marginTop: 8 }}>
          К сожалению, заявка устарела
        </p>
      </div>

      <div className="sign__btns">
        <Button buttonType="primary" size="m" isFull onClick={closeModal}>
          Создать новую заявку
        </Button>
      </div>
    </div>
  );
};

export default ProspectusErrorScreen;
